import React, { PropsWithChildren } from 'react';

import './style.less';
import { useWindowSize } from '@/hooks';

interface Props {
  loading: boolean;
  skeletonCount?: number;
  skeletonType?: 'TAB' | 'INPUT';
  style?: React.CSSProperties;
}

const SkeletonCustom: React.FC<PropsWithChildren<Props>> = ({
  skeletonCount: skeletonTab = 3,
  skeletonType = 'TAB',
  style,
  ...props
}) => {
  const { isMobile } = useWindowSize();

  return (
    <>
      {props.loading && skeletonType === 'INPUT' && (
        <div className="skeleton-input-container">
          {Array.from({ length: skeletonTab }).map((_, index) => (
            <div
              className="skeleton-input skeleton-loading"
              style={{ ...style }}
              key={index}
            />
          ))}
        </div>
      )}

      {props.loading && skeletonType === 'TAB' && (
        <div className="skeleton-tab-container">
          <div className="tab-flex-container">
            <div className="tab-flex-container">
              {Array.from({ length: skeletonTab }).map((_, index) => (
                <div
                  className="skeleton-loading skeleton-tab"
                  key={index}
                  style={{ ...style }}
                />
              ))}
            </div>

            {!isMobile && <div className="skeleton-loading skeleton-tab" />}
          </div>

          <div className="skeleton-loading skeleton-tab-content" />
        </div>
      )}

      {!props.loading && props.children}
    </>
  );
};

export default SkeletonCustom;
